import { useRef, useState } from "react";
import InteractionLottie from "../InteractionLottie/InteractionLottie";
import styles from "./InteractionIcon.module.scss";

const InteractionIcon = ({
  item: { name, lottie, icon, count, selectedColor },
  handleEmoji,
}) => {
  const iconRef = useRef(null);
  const [play, setPlay] = useState(false);

  const handleEmojiClick = (name) => {
    setPlay(true);
    handleEmoji(name);
    animate();
  };

  const animate = () => {
    if (!iconRef.current) return;
    iconRef.current.classList.add("clickedReaction");
    document.documentElement.style.setProperty(
      "--tooltip-color",
      selectedColor
    );
    setTimeout(() => {
      iconRef.current.classList.remove("clickedReaction");
      document.documentElement.style.setProperty("--tooltip-color", "#fff");
    }, 2000);
  };

  return (
    <div
      ref={iconRef}
      className={`${styles.imgContainer}`}
      onClick={() => handleEmojiClick(name)}
    >
      <img src={icon} alt="" />
      <InteractionLottie lottieData={lottie} play={play} setPlay={setPlay} />
      <span className={styles.tooltiptext}>{name}</span>
      <div className={styles.count}>{count}</div>
    </div>
  );
};

export default InteractionIcon;
